import core from './core';

export default {
  get({ search, nationality, status, arrival_at, page, per_page, sort, direction } = {}) {
    return core.get('flights', {
      params: { search, nationality, status, arrival_at, page, per_page, sort, direction }
    });
  },
}
